<app-dialog-container
    class="dialog-wrapper custom-dimension"
    [loading]="false"
    (closeEvent)="closeDialog()"
    [title]="'Save Report'"
    data-cy="load-report-dialog-container"
>
    <div class="ra-primary-blue has-text-centered label-wrapper">
        <label class="has-text-weight-semibold">Load Saved Report</label>
    </div>

    <input
        matInput
        #reportSearch
        placeholder="Search for a report."
        [hidden]="savedReports.length === 0"
        class="search-box"
    />

    <div class="scroll-bar">
        <!-- Template to reuse -->
        <ng-template
            #reportList
            let-title
            let-list="list"
        >
            <div *ngIf="list.length > 0">
                <span style="font-weight: bold">{{ title }}</span>
                <ul>
                    <li
                        *ngFor="let reportOptionRaw of list | searchFilter: reportSearch.value : 'reportName'"
                        style="margin-top: 3px"
                    >
                        <ng-container *ngIf="$any(reportOptionRaw) as reportOption">
                            <div
                                class="report-container"
                                [class.default-report]="canSetDefault && reportOption.isDefault"
                            >
                                <div style="flex: 1; overflow: hidden">
                                    <div class="report-action-button report-name">
                                        <button
                                            class="button noshadow report-button ellipsis"
                                            [matTooltip]="
                                                !reportOption.isReportOwner && reportOption.creatorName
                                                    ? reportOption.reportName + ' — Created by ' + reportOption.creatorName
                                                    : reportOption.reportName
                                            "
                                            [class.report-active]="report && report.reportName === reportOption.reportName"
                                            style="width: 100%"
                                            (click)="loadFilters(reportOption)"
                                        >
                                            {{ reportOption.reportName }}
                                        </button>
                                    </div>
                                </div>
                                <div class="buttons-container">
                                    <span
                                        *ngIf="canSetDefault && reportOption.isDefault"
                                        class="tag default-tag"
                                        data-cy="default-report-tag"
                                        >Default</span
                                    >
                                    <div class="report-action-button">
                                        <button
                                            class="button noshadow report-button"
                                            (click)="toggleIsFavorited(reportOption)"
                                        >
                                            <i
                                                [ngClass]="{ far: !reportOption.isFavorited, fas: reportOption.isFavorited }"
                                                class="far fa-star"
                                                aria-hidden="true"
                                            ></i>
                                        </button>
                                    </div>
                                    <div class="report-action-button">
                                        <button
                                            class="button noshadow report-button"
                                            (click)="openEmailReportDialog(reportOption)"
                                        >
                                            <i
                                                *ngIf="
                                                    isConfiguredEmailReport(reportOption) &&
                                                    !isEndDatePassed(reportOption?.emailReports?.endDate)
                                                "
                                                class="fas fa-envelope"
                                                aria-hidden="true"
                                            ></i>
                                            <i
                                                *ngIf="
                                                    !isConfiguredEmailReport(reportOption) ||
                                                    isEndDatePassed(reportOption?.emailReports?.endDate)
                                                "
                                                class="far fa-envelope"
                                                aria-hidden="true"
                                            ></i>
                                        </button>
                                    </div>
                                    <div class="report-action-button">
                                        <button
                                            [matMenuTriggerFor]="menu"
                                            class="button noshadow report-button"
                                            aria-label="Example icon-button with a menu"
                                        >
                                            <i
                                                class="fa fa-ellipsis-v"
                                                aria-hidden="true"
                                            ></i>
                                        </button>

                                        <mat-menu #menu="matMenu">
                                            <button
                                                mat-menu-item
                                                class="menu-button"
                                                (click)="openEditReportDialog(reportOption)"
                                                *ngIf="
                                                    reportOption.isReportOwner ||
                                                    userConfig.roleCapability.rate_optics.general.manage_all_reports
                                                "
                                            >
                                                <span><i class="fas fa-pen-to-square"></i></span> Edit Report
                                            </button>
                                            <button
                                                mat-menu-item
                                                class="menu-button"
                                                (click)="copyReportLink(reportOption)"
                                            >
                                                <span><i class="fas fa-link"></i></span> Share Report
                                            </button>
                                            <button
                                                mat-menu-item
                                                class="menu-button"
                                                (click)="toggleIsDefault(reportOption)"
                                                *ngIf="canSetDefault"
                                                data-cy="toggle-default-report"
                                            >
                                                <span><i class="fas fa-star"></i></span>
                                                {{ reportOption.isDefault ? 'Remove as Default' : 'Set as Default' }}
                                            </button>
                                            <button
                                                mat-menu-item
                                                class="menu-button"
                                                (click)="openDeleteReportDialog(reportOption)"
                                            >
                                                <span><i class="fas fa-trash-alt"></i></span> Delete Report
                                            </button>
                                        </mat-menu>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </li>
                </ul>
            </div>
        </ng-template>

        <!-- Render each section using the template -->
        <ng-container *ngTemplateOutlet="reportList; context: { $implicit: 'Favorites', list: favoriteReports }"></ng-container>
        <ng-container *ngTemplateOutlet="reportList; context: { $implicit: 'My Global Reports', list: myGlobalReports }"></ng-container>
        <ng-container *ngTemplateOutlet="reportList; context: { $implicit: 'My Reports', list: myReports }"></ng-container>
        <ng-container *ngTemplateOutlet="reportList; context: { $implicit: 'Global Reports', list: globalReports }"></ng-container>
        <ng-container *ngTemplateOutlet="reportList; context: { $implicit: 'Expired Reports', list: expiredReports }"></ng-container>
    </div>

    <div *ngIf="savedReports.length === 0">
        <span style="font-weight: bold">No reports saved.</span>
    </div>
    <br />
    <div class="report-container justify-center">
        <app-button
            [buttonText]="'Load Report'"
            [icon]="'fa-folder-open'"
            [isLoading]="isDeleting"
            [disabled]="!filter || isDeleting"
            [type]="'flat'"
            (buttonClick)="loadFiltersAndClose()"
        />
    </div>
</app-dialog-container>
